/** @jsxImportSource @emotion/react */
import { useLingui } from '@lingui/react/macro';
import type { FormikHelpers } from 'formik';
import { SocialNetType } from 'modules/organizer/domain/interfaces/social-net';
import { upsertSocialNets } from 'modules/organizer/store/social-nets';
import useSocialNets from 'modules/organizer/ui/hooks/use-social-nets';
import SocialNetForm, { InitialValues } from 'modules/settings/ui/components/social-net-components/form/social-net-form';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import type { AppDispatch } from 'store/store';
import type { DivProps } from 'typings';

interface IProps extends DivProps {}

function SocialNet(props: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useLingui();
  const { isLoading, isProcessing, socialNet } = useSocialNets();
  const initialValue = {
    website: socialNet.find((item) => item.type === SocialNetType.TOURNAMENT_SITE)?.url?.toString(),
    vk: socialNet.find((item) => item.type === SocialNetType.VK)?.url?.toString(),
    'vk-video': socialNet.find((item) => item.type === SocialNetType.VK_VIDEO)?.url?.toString(),
    telegram: socialNet.find((item) => item.type === SocialNetType.TELEGRAM)?.url?.toString(),
    youtube: socialNet.find((item) => item.type === SocialNetType.YOUTUBE)?.url?.toString(),
    instagram: socialNet.find((item) => item.type === SocialNetType.INSTAGRAM)?.url?.toString(),
  };

  const onSubmit = useCallback(
    (values: InitialValues, helpers: FormikHelpers<InitialValues>) => {
      dispatch(upsertSocialNets(values))
        .unwrap()
        .then(() => {
          toast.success(t`Ссылки успешно сохранены`);
        })
        .catch(() => {
          toast.error(t`Не удалось сохранить ссылки`);
        });
      helpers.setSubmitting(false);
    },
    [dispatch, t],
  );

  return <SocialNetForm initialValues={initialValue} onSubmit={onSubmit} loading={isProcessing} loader={isLoading} />;
}

export default SocialNet;
